import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, Typography } from '@duxton-web/ui';

interface ContextualRulesExceptionModalProps {
  open: boolean;
  actionLabel?: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

const ContextualRulesExceptionModal = ({
  open,
  actionLabel = 'Save',
  onConfirm,
  onCancel,
}: ContextualRulesExceptionModalProps) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  return (
    <Modal
      title="Contextual Rules Exception"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      closable={false}
      centered
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button size="small" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            size="small"
            type="primary"
            disabled={!reason.trim()}
            onClick={() => onConfirm(reason)}
          >
            {actionLabel}
          </Button>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Typography.Text>
          This variable has no contextual rules configured. Please provide a
          reason for this exception before proceeding.
        </Typography.Text>
        <Input.TextArea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason for exception..."
          rows={4}
          autoFocus
        />
      </div>
    </Modal>
  );
};

export default ContextualRulesExceptionModal;
